import React from "react";

export default function ToolsView() {
  
  return (
    <div>ToolsView</div>
  );

}
